import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

import useNav from "core/hooks/useNav";
import usePageShow from "core/hooks/usePageShow";

import Box from "ui/atom/Box";
import Title from "ui/base/Title";
import Content from "ui/Content";

import { useArticle } from "features/article/fabric";


export default function Articles({ title, subtitle, articles, center, loading, read = true, ordered = undefined }) {
	const article = useArticle();
	const nav = useNav();
	const theme = useTheme();
	const [navigating, setNavigating] = useState(null);

	usePageShow(() => {
		setNavigating(null);
		article.store.setDisabled(false);
	});

	const hasArticles = articles?.length > 0;
	const list = hasArticles ? articles : [...Array(5).fill(null)];

	const style = {
		root: {
			alignItems: "center",
			textAlign: "center",
			overflow: "visible",
			"& .swiper-slide": {
				position: "relative",
				maxWidth: "270px",
				transition: "all 200ms ease",
				":hover": {
					scale: 1.05,
					zIndex: 2,
					cursor: article.disabled ? "default" : "pointer"
				}
			}
		},
		swiper: {
			width: "100%",
			overflow: "visible",
			padding: theme.spacing(0, 1.25)
		}
	};

	const click = (art) => {
		if (article.disabled) return;

		if (read) article.unlock(art?.id);
		else nav.open(art?.url);

		setNavigating(art?.id);
	};

	if (!loading && !hasArticles) return null;
	return (
		<Box.Column gap={4} sx={style.root}>
			<Title title={title} subtitle={subtitle} center={center} />
			<Swiper height="max-content" spaceBetween={10} slidesPerView="auto" style={style.swiper}>
				{list.map((a, k) => (
					<SwiperSlide key={k}>
						<Content
							article={a}
							order={ordered && k}
							toggleBookmark={article.toggleBookmark}
							onClick={() => click(a)}
							navigating={navigating === a?.id}
						 />
					</SwiperSlide>
				))}
			</Swiper>
		</Box.Column>
	);
}